import React from 'react';
import Banner from '../Components/Banner';
import Accordian from '../Accordian/Accordian';
import { useLanguage } from '../context/LanguageContext';

function Faqs() {
  const { t } = useLanguage();

  return (
    <div className="page-wrap">
      <Banner
        pageName={t.pages.faqs}
        pageLink="/faqs"
        subtitle={t.faqs.subtitle}
        eyebrow="Innovative Horizons"
        image="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1800&q=80"
      />

      <section className="section">
        <div className="container">
          <div className="section-title center">
            <div className="eyebrow">Support</div>
            <h2>{t.pages.faqs}</h2>
            <p>{t.faqs.subtitle}</p>
          </div>

          <div className="faq-shell">
            <Accordian />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Faqs;